"use client";

import { TimerCountdown } from "politicamente-informados-ds";

export type IBlockTimer = {
    attrs: {
        title?: string | undefined;
        date?: string | undefined;
        message?: string | undefined;
    };
};

export default function BlockTimerContdown({ attrs }: IBlockTimer) {
    const { date, message } = attrs || {};

    return (
        <div>
            <TimerCountdown title={message ?? ""} targetDate={date ?? ""} />
        </div>
    );
}
